import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'animate.css/animate.min.css';

Vue.config.productionTip = false;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(vueSwiper)

/* 引入aos动画库相关文件 */
import AOS from 'aos'
import 'aos/dist/aos.css'


/* aos动画初始化 */
AOS.init({
    offset: 120,
    duration: 2000,
    easing:"ease-in-out",
    'anchor-placement':'top-bottom'
});

router.beforeEach((to, from, next) =>{
    if(to.path=='/doc'){
        let a=document.createElement('a') //创建一个a标签元素
        a.style.display='none'  //设置元素不可见
        a.href='/doc/1.pdf' //设置下载地址
        a.download="干细胞资源库大数据管理平台解决方案.pdf"
        document.body.appendChild(a)  //加入
        a.click() //触发点击,下载
        document.body.removeChild(a) /释放
    }else {
        next();
    }


})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
